"use strict";

import VanillaSmoothScroll from "./VanillaSmoothScroll";

import "../scss/style.scss";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new VanillaSmoothScroll();
  },
  false,
);
